export default "__VITE_ASSET__R7I8nauC__"